// headerFixed：一部ページにてスクロール途中でheaderを表示する

export default function headerFixed() {
  // PC/SP判定
  if($('body').hasClass('is-sp')){
    spHeaderFixed();
  }
  else {
    pcHeaderFixed();
  }

  // SPの固定ヘッダー表示設定
  function spHeaderFixed(){
    var $fixedHeader = $('.header-fixed');
    var firstViewHeight = 580;

    scroll($fixedHeader, firstViewHeight);
  }

  // PCの固定ヘッダー表示設定
  function pcHeaderFixed(){
    var $fixedHeader = $('header').find('.header_menu');
    var firstViewHeight = $('header').height();
    if($('main#top').length) {
      firstViewHeight = $('.top-hero').height();
    }


    scroll($fixedHeader, firstViewHeight)
  }
  
  // ヘッダー表示制御
  function scroll($target, h){
    $(window).on('scroll', function(){
      if($(window).scrollTop() >= h) {
        $target.addClass('is_show');
      }
      else {
        $target.removeClass('is_show');
      }
    });
  }

}


// WEBPACK FOOTER //
// ./js/module/headerFixed.js